import OutlineButton from "./common/outline-btn";

export default function Growth({ toggleModal }) {
  return (
    <section className="relative block w-full lg:py-[70px] py-[40px] overflow-hidden">
      <div className="container mx-auto xl:px-0 lg:px-8 md:px-6 px-4">
        <div className="lg:grid flex flex-col gap-8 grid-cols-2 w-full relative overflow-hidden items-center">
          <div className="lg:order-1 order-2">
            <div
              className="relative"
              data-aos="fade-left"
              data-aos-duration="2600"
            >
              <div className="lg:p-14 p-0">
                <h2 className="lg:text-[50px] text-[35px] font-bold lg:leading-[65px] leading-[41px] tracking-tight mb-5">
                  Your App Scale with Your Success
                </h2>
                <p className="text-base font-normal leading-6 text-black mb-4">
                  We design apps with scalability in mind, ensuring that our
                  software infrastructure can handle millions of users
                  effortlessly.
                </p>

                <p className="text-base font-normal leading-6 text-black mb-6">
                  Once your app is developed, you won’t face any challenges
                  managing user load, no matter how fast your business expands.
                </p>
                <OutlineButton
                  toggleModal={toggleModal}
                  title={"Talk to an Expert"}
                />
              </div>
            </div>
          </div>
          <div className="lg:order-2 order-1 z-10 lg:mb-0 mb-6">
            <div data-aos="fade-right" data-aos-duration="2200">
              <div>
                <img
                  src="https://glocify.com/images/growth-hero-mob.png"
                  alt="growth-hero"
                  className="w-full"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="colorAnimation" />
    </section>
  );
}
